/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ContractorView} from "../../contractor/views/ContractorView";
const route = [{webpackEntry: "contractor", path: rpAppPath.contractor.base, component: ContractorView}];

(function () {
    rpClient(route);
})();
/*
 * This file is generated by generate_webpack_entries.ts
 */
import {rpAppPath} from "@pg-mono/rp-routes";

import {rpClient} from "../../../client/rp_client";
import {ContractorView} from "../../contractor/views/ContractorView";
const route = [{webpackEntry: "contractor", path: rpAppPath.contractor.base, component: ContractorView}];

(function () {
    rpClient(route);
})();
